$(function ($) {

  $('form').each(function () {
    $(this).validate({
      highlight: function (e) {
        $(e).parent().addClass('invalid');
      },
      unhighlight: function (e) {
        $(e).parent().removeClass('invalid');
      }
    });
  });

  $('.calculator-form').on('submit', function (e) {
    if (!$(this).valid()) {
      e.preventDefault();
    }
  });

  const ctx = $('#eye-colors');
  const blueEyes = parseInt(ctx.data('blue'));
  const greenEyes = parseInt(ctx.data('green'));
  const hazelEyes = parseInt(ctx.data('hazel'));
  const darkEyes = parseInt(ctx.data('dark'));
  const myChart = new Chart(ctx, {
    type: 'pie',
    data: {
      labels: [
        'Сини',
        'Зелени',
        'Пъстри',
        'Тъмни'
      ],
      datasets: [{
        label: 'Eye colors',
        data: [blueEyes, greenEyes, hazelEyes, darkEyes],
        backgroundColor: [
          '#0F52C4',
          '#51C40F',
          '#B69450',
          '#000000'
        ],
        hoverOffset: 4
      }]
    },
    options: {
      plugins: {
        legend: false,
        labels: {
          render: 'value',
          fontColor: '#000',
          position: 'outside',
          fontSize: 14,
          fontStyle: 'bold',
          render: (args) => {
            return `${args.value}%`;
          }
        }
      },
      responsive: false,
      tooltips: { 
        enabled: false 
      },
    }
  });

});
